@if (contentLoaded) {
	<div class="container">
		<div class="row mb-4">
			<div [innerHTML]="pageConfig.content.introduction"></div>
		</div>
		<div class="row mb-4">
			<div class="col-lg-4 col-md-4 col-sm-12 col-12 p-2">
				<app-multi-link-accordion [accordion]="pageConfig.content.linkAccordion"></app-multi-link-accordion>
			</div>
			<div class="col-lg-8 col-md-8 col-sm-12 col-12 p-2">
				<h2 class="mb-4 title-bottom-line">Filtri</h2>
				<app-filter-group
					[asAccordion]="true"
					[filters]="visibleFilters"
					[filterMapper]="filterMapper"
					(filterChanged)="setNewFilterStatus($event)"></app-filter-group>
				@if (showReportError) {
					<div class="row mt-3 justify-content-center">
						<div class="alert alert-danger my-alert m-0" role="alert">
							<span> Non è stato possibile generare il report. Per favore riprova più tardi. </span>
						</div>
					</div>
				}
				<div class="row mt-3 gap-2 p-0 justify-content-center">
					<div class="col-12 col-lg-3 p-0">
						<app-call-to-action-btn
							[showLoadingSpinner]="loadingVisualizeReport"
							innerClass="btn btn-primary"
							label="VISUALIZZA"
							iconColor="white"
							iconName="it-password-visible"
							(clicked)="visualizeReport()"></app-call-to-action-btn>
					</div>
					<div class="col-12 col-lg-3 p-0">
						<app-call-to-action-btn
							[showLoadingSpinner]="loadingDownloadPdfReport"
							innerClass="btn btn-outline-primary"
							label="SCARICA PDF"
							iconColor="black"
							iconName="it-file-pdf-ext"
							(clicked)="downloadPdfReport()"></app-call-to-action-btn>
					</div>
					<div class="col-12 col-lg-3 p-0">
						<app-call-to-action-btn
							[showLoadingSpinner]="loadingDownloadXlsReport"
							innerClass="btn btn-outline-primary"
							label="SCARICA EXCEL"
							iconColor="black"
							iconName="it-file-sheet"
							(clicked)="downloadXlsReport()"></app-call-to-action-btn>
					</div>
				</div>
				<div class="row mb-3 mt-1 p-0 d-flex justify-content-center">
					NOTA: l'elaborazione potrebbe richiedere più secondi se i filtri impostati sono poco stringenti.
				</div>
			</div>
		</div>
	</div>
} @else if (showPageError) {
	<app-page-error></app-page-error>
} @else {
	<app-loading-spinner></app-loading-spinner>
}
